import { lazy } from 'react';

const PaidPaymentConfig = {
  settings: {
    layout: {
      style: 'layout1',
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        mode: 'fullwidth',
      },
    },
  },
  routes: [
    {
      path: '/paidpayment',
      component: lazy(() => import('./PaidPayment')),
    },
  ],
};

export default PaidPaymentConfig;
